module.exports = __webpack_public_path__ + "static/img/home_services_dev.63e7d00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_services_dev.svg
// module id = 164
// module chunks = 2